import React from 'react'
import Navbar from '../components/Navbar'

function AboutUs() {
  return (
    <>
      <Navbar page={'about'} />
      <div className='h-[92vh] w-full bg-aboutus bg-cover bg-no-repeat'>
        <div className='bg-black opacity-65 w-full h-full flex flex-col justify-center items-center'>
          <div className='p-3 h-2/3 w-2/3'>
            <h1 className='mb-4 text-center text-white text-3xl font-open-sans font-medium'>About Us</h1>
            <p className='text-center text-white text-xl font-roboto font-light'>
              Shiv Traders, a prominent building materials supplier in Dalli Rajhara, offers an extensive range 
              of premium products for both construction professionals and DIY home improvers. Their collection 
              spans from sturdy TMT bars and essential hardware to stylish sanitary ware and reliable power tools, 
              empowering customers to tackle any project with confidence. Renowned for exceptional service and 
              competitive value, Shiv Traders is your one-stop shop for building success.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default AboutUs